import standardAPI from '@/api/standard_items';

const state = {
  nationalities: [],
  nationalities_status: '',
  nationalities_MetaData: {},
  nationalities_page: 1,
  nationalities_perPage: 10,
};

const responseUrl = '/nationalities';

const getters = {};

const actions = {
  set_current_page ({ commit }, page) {
    commit('SET_CURRENT_PAGE', page);
  },
  set_perPage ({ commit }, max) {
    commit('SET_PER_PAGE', max);
  },
  fetch_nationalities ({ commit }, getOptions) {
    commit('NATIONALITIES_REQUEST');
    const preparedOptions = {
      getParams: getOptions.pageOptions,
      url: responseUrl,
      token: getOptions.token,
    };
    return new Promise((resolve, reject) => {
      standardAPI.get_items((response) => {
        try {
          if (response && response.status !== 404) {
            commit('NATIONALITIES_SUCCESS', response);
            commit('NATIONALITIES_READY');
            resolve(response);
          } else if (response.status === 404) {
            commit('NATIONALITIES_READY');
            reject(response);
          } else {
            commit('NATIONALITIES_ERROR');
            reject(response);
          }
        } catch (error) {
          console.log(error);
        }
      }, preparedOptions);
    });
  },
  add_nationality ({ commit, dispatch }, itemData) {
    commit('NATIONALITIES_REQUEST');
    const preparedData = {
      itemData: itemData,
      url: responseUrl,
    };
    return new Promise((resolve, reject) => {
      standardAPI.add_item(preparedData, (response) => {
        if (response.status === 'created') {
          resolve(response);
        } else {
          commit('NATIONALITIES_READY');
          reject(response);
        }
      });
    });
  },
  edit_nationality ({ commit, dispatch }, itemData) {
    commit('NATIONALITIES_REQUEST');
    const preparedData = {
      itemData: itemData,
      url: responseUrl + '/',
    };
    return new Promise((resolve, reject) => {
      standardAPI.edit_item(preparedData, (response) => {
        if (response.status === 'updated') {
          resolve(response);
        } else {
          commit('NATIONALITIES_READY');
          reject(response);
        }
      });
    });
  },
  remove_nationality ({ commit, dispatch }, itemData) {
    commit('NATIONALITIES_REQUEST');
    const preparedData = {
      itemData: itemData,
      url: responseUrl,
    };
    return new Promise((resolve, reject) => {
      standardAPI.remove_items(preparedData, (response) => {
        if (response.status === 'deleted') {
          resolve(response);
        } else {
          commit('NATIONALITIES_READY');
          reject(response);
        }
      });
    });
  },
  reorder_nationality ({ commit, dispatch }, orderData) {
    const preparedData = {
      orderData: orderData,
      url: responseUrl + '/reorder',
    };
    return new Promise((resolve, reject) => {
      standardAPI.reorder_item(preparedData, (response) => {
        if (response.status === 'reorder') {
          resolve(response);
        } else {
          reject(response);
        }
      });
    });
  },
};

const mutations = {
  SET_CURRENT_PAGE: (state, pageNumber) => {
    state.nationalities_page = pageNumber;
  },
  SET_PER_PAGE: (state, max) => {
    state.nationalities_perPage = max;
  },
  NATIONALITIES_READY: (state) => {
    state.nationalities_status = 'ready';
  },
  NATIONALITIES_REQUEST: (state) => {
    state.nationalities_status = 'loading';
  },
  NATIONALITIES_SUCCESS: (state, response) => {
    if (response && response.meta) {
      state.nationalities_MetaData.meta = response.meta;
      state.nationalities_MetaData.links = response.links;
    }
    state.nationalities = response.data;
    state.nationalities_status = 'success';
  },
  NATIONALITIES_ERROR: (state) => {
    state.nationalities_status = 'error';
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
